/**
 * @generated SignedSource<<eb4b403829ac0329721693a2082ba5b7>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeleteShopifyRecurringChargesTaskInput = {
  salesChannelID?: string | null;
};
export type salesChannelSwitchQueriesGenerateDeleteShopifyRecurringChargesTaskMutation$variables = {
  input: DeleteShopifyRecurringChargesTaskInput;
};
export type salesChannelSwitchQueriesGenerateDeleteShopifyRecurringChargesTaskMutation$data = {
  readonly generateDeleteShopifyRecurringChargesTask: {
    readonly taskID: number;
  } | null;
};
export type salesChannelSwitchQueriesGenerateDeleteShopifyRecurringChargesTaskMutation = {
  response: salesChannelSwitchQueriesGenerateDeleteShopifyRecurringChargesTaskMutation$data;
  variables: salesChannelSwitchQueriesGenerateDeleteShopifyRecurringChargesTaskMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ProductSwitcherTaskOutput",
    "kind": "LinkedField",
    "name": "generateDeleteShopifyRecurringChargesTask",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "taskID",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "salesChannelSwitchQueriesGenerateDeleteShopifyRecurringChargesTaskMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "salesChannelSwitchQueriesGenerateDeleteShopifyRecurringChargesTaskMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "834300b4d4dc3cfe7afdacdffd666b0e",
    "id": null,
    "metadata": {},
    "name": "salesChannelSwitchQueriesGenerateDeleteShopifyRecurringChargesTaskMutation",
    "operationKind": "mutation",
    "text": "mutation salesChannelSwitchQueriesGenerateDeleteShopifyRecurringChargesTaskMutation(\n  $input: DeleteShopifyRecurringChargesTaskInput!\n) {\n  generateDeleteShopifyRecurringChargesTask(input: $input) {\n    taskID\n  }\n}\n"
  }
};
})();

(node as any).hash = "86e3ebb02470983373cfc3b3ea9d8d21";

export default node;
